import Dropzone from 'dropzone';

export default class {

    constructor() {

        let zones = document.querySelectorAll('[data-dropzone]');

        if (zones.length === 0) {
            return;
        }

        window._.forEach(zones, this.newZone);

    }

    newZone(element) {

        let instance = $(element),
            url = instance.data('url'),
            remove = instance.data('remove'),
            extensions = instance.data('ext'),
            placeholder = instance.find('span.placeholder'),
            token = instance.closest('[data-form-wrapper]').find('input[name="_token"]').val();

        new Dropzone(element, {
            url: url + '/' + token,
            addRemoveLinks: true,
            removedfile: (file) => {
                this.remove(remove, file.name, token);
                let ref = file.previewElement;
                return (ref !== null) ?
                    ref.parentNode.removeChild(file.previewElement) :
                    void 0;
            },
            acceptedFiles: extensions
        });

    }

    remove(url, file, token) {

        window.axios.get(url + file + '/' + token);

    }

}


// WEBPACK FOOTER //
// ./resources/js/src/core/DropUpload.js